<div class="flex flex-col gap-6">
  <div class="flex">
    <div class="flex flex-col flex-1">
      <h3 class="text-on-surface dark:text-on-surface-darkmode font-semibold">
        {{ 'cockpit.energyInterfaces.details.loadCurve.sectionTitle' | transloco }}
      </h3>
      <p class="text-sm text-on-surface-variant dark:text-on-surface-variant-darkmode">
        {{ 'cockpit.energyInterfaces.details.loadCurve.sectionSubtitle' | transloco }}
      </p>
    </div>
  </div>
  <ui-alert class="block">
    <ng-icon slot="icon" name="heroInformationCircle" size="20" class="!block" />
    <h3 slot="title">
      {{ 'cockpit.energyInterfaces.details.loadCurve.loadProfileAlert.title' | transloco }}
    </h3>
    <p>
      {{ 'cockpit.energyInterfaces.details.loadCurve.loadProfileAlert.message' | transloco }}
    </p>
  </ui-alert>
  @if (detailsPage.state()?.isLoading) {
    <ui-skeleton class="h-50 w-full rounded-lg" />
  } @else if (
    detailsPage.state()?.data?.status === 'UNATTACHED' ||
    detailsPage.state()?.data?.status === 'ATTACHED'
  ) {
    <div class="flex flex-col gap-2">
      <h3 class="text-sm font-semibold">
        {{ 'cockpit.energyInterfaces.details.loadCurve.loadProfileStatusLabel' | transloco }}
      </h3>
      <div>
        @switch (detailsPage.state()?.data?.loadProfileStatus) {
          @case ('NONE') {
            <ui-badge
              [uiTooltip]="
                'cockpit.energyInterfaces.details.loadCurve.statusTooltipNone' | transloco
              "
            >
              {{ 'cockpit.energyInterfaces.details.loadCurve.statusNone' | transloco }}
            </ui-badge>
          }
          @case ('IGNORE') {
            <ui-badge
              [uiTooltip]="
                'cockpit.energyInterfaces.details.loadCurve.statusTooltipNone' | transloco
              "
            >
              {{ 'cockpit.energyInterfaces.details.loadCurve.statusNone' | transloco }}
            </ui-badge>
          }
          @case ('STALE') {
            <ui-badge
              color="primary"
              [uiTooltip]="
                'cockpit.energyInterfaces.details.loadCurve.statusTooltipStale' | transloco
              "
            >
              {{ 'cockpit.energyInterfaces.details.loadCurve.statusStale' | transloco }}
            </ui-badge>
          }
          @case ('PROCESSING') {
            <ui-badge
              color="primary"
              [uiTooltip]="
                'cockpit.energyInterfaces.details.loadCurve.statusTooltipProcessing' | transloco
              "
            >
              {{ 'cockpit.energyInterfaces.details.loadCurve.statusProcessing' | transloco }}
            </ui-badge>
          }
          @case ('IN_SYNC') {
            <ui-badge color="success">
              {{ 'cockpit.energyInterfaces.details.loadCurve.statusInSync' | transloco }}
            </ui-badge>
          }
          @case ('FAILED') {
            <ui-badge
              color="error"
              [uiTooltip]="
                detailsPage.state()?.data?.loadProfileStatusFailedReason ??
                ('cockpit.energyInterfaces.details.loadCurve.statusFailedUnknownReason' | transloco)
              "
            >
              {{ 'cockpit.energyInterfaces.details.loadCurve.statusFailed' | transloco }}
            </ui-badge>
          }
          @default {
            <ui-badge
              color="error"
              [uiTooltip]="
                detailsPage.state()?.data?.loadProfileStatus ??
                ('cockpit.energyInterfaces.details.loadCurve.statusUnknown' | transloco)
              "
            >
              {{ 'cockpit.energyInterfaces.details.loadCurve.statusFailed' | transloco }}
            </ui-badge>
          }
        }
      </div>
    </div>

    <app-energy-interface-load-curve-upload
      [organizationId]="detailsPage.organizationId()"
      [energyInterfaceId]="detailsPage.energyInterfaceId()"
    />
  } @else {
    <ui-alert color="warning">
      <ng-icon slot="icon" name="heroExclamationTriangle" size="20" class="!block" />
      <h3 slot="title">
        {{ 'cockpit.energyInterfaces.details.loadCurve.incompleteAlert.title' | transloco }}
      </h3>
      <p>
        {{ 'cockpit.energyInterfaces.details.loadCurve.incompleteAlert.message' | transloco }}
      </p>
    </ui-alert>
  }
</div>
